export enum PlanStatusEnum {
    ACTIVE = "Ativo",
    CANCELLATION_PENDING = "Cancelamento Pendente",
    OVERDUE = "Atrasado",
    CANCELED = "Cancelado",
    FULLY_CANCELED = "Totalmente Cancelado",
    ACTIVATION_PENDING = "Ativação Pendente",
    FINALIZED = "Finalizado",
    UNKNOWN = "Desconhecido",
}

export const PlanStatusLabelIdMap: Record<PlanStatusEnum, string> = {
    [PlanStatusEnum.ACTIVE]: "intl-msg:shared.plan.status.active",
    [PlanStatusEnum.CANCELLATION_PENDING]: "intl-msg:shared.plan.status.cancellationPending",
    [PlanStatusEnum.OVERDUE]: "intl-msg:shared.plan.status.overdue",
    [PlanStatusEnum.CANCELED]: "intl-msg:shared.plan.status.canceled",
    [PlanStatusEnum.FULLY_CANCELED]: "intl-msg:shared.plan.status.fullyCanceled",
    [PlanStatusEnum.ACTIVATION_PENDING]: "intl-msg:shared.plan.status.activationPending",
    [PlanStatusEnum.FINALIZED]: "intl-msg:shared.plan.status.finalized",
    [PlanStatusEnum.UNKNOWN]: "intl-msg:shared.plan.status.unknown",
};